export default {
  common: {
    menu: 'Menu',
    error: 'Błąd',
    no: 'Nie',
    search: 'Szukaj',
    selected: 'Wybrano',
    yes: 'Tak',
  },
  actions: {
    clear: 'Wyczyść',
  },
};
